import styled from 'styled-components';

const Body = styled.p`
  text-align: ${props => props.center && 'center'};
  color: ${props => props.color};
  font-size: ${props => props.size}px;
  font-weight: ${props => props.weight || 500};
`;

const Heading = styled.h1`
  text-align: ${props => props.center && 'center'};
  color: ${props => props.color};
  font-size: ${props => props.size}px;
  font-weight: ${props => props.weight || 700};
`;

const Text = { Body, Heading };

export default Text;
